import React from "react";

// Helper function to parse markdown bold (**text**) and render as HTML
const parseMarkdownBold = (text: string) => {
  if (!text) return text;
  const parts = text.split(/(\*\*.*?\*\*)/g);
  return parts.map((part, index) => {
    if (part.startsWith("**") && part.endsWith("**")) {
      const boldText = part.slice(2, -2);
      return <strong key={index}>{boldText}</strong>;
    }
    return <span key={index}>{part}</span>;
  });
};

interface AnswerResultProps {
  answerResult: any;
}

const AnswerResult: React.FC<AnswerResultProps> = ({ answerResult }) => {
  if (!answerResult) return null;

  const score = parseInt(answerResult.score);
  const scoreColorClass =
    score >= 70 ? "bg-success" : score >= 50 ? "bg-warning" : "bg-danger";

  return (
    <div className="mt-4">
      <div className="card border-0 shadow-sm">
        <div className="card-body">
          <div className="d-flex align-items-center justify-content-between mb-3">
            <h3 className="mb-0">Result</h3>
            {answerResult.score && (
              <span className={`badge ${scoreColorClass} fs-3`}>
                Score: {answerResult.score}
              </span>
            )}
          </div>
          {answerResult.score && (
            <div className="mb-3">
              <div className="progress progress-xs mb-2" role="progressbar">
                <div
                  className={`progress-bar ${scoreColorClass}`}
                  style={{
                    width: Math.min(100, Math.max(0, answerResult.score)) + "%",
                  }}
                />
              </div>
            </div>
          )}
          <div className="row">
            <div className="col-12 mb-4">
              <div className="card h-100 border-0 bg-light">
                <div className="card-body">
                  <h6 className="text-dark mb-2">
                    <i className="isax isax-message me-2" />
                    Answer
                  </h6>
                  <div className="text-muted" style={{ whiteSpace: "pre-line" }}>
                    {parseMarkdownBold( answerResult.answer)}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 mb-3">
              <div className="card h-100 border-0 bg-light">
                <div className="card-body">
                  <h6 className="text-dark mb-2">
                    <i className="isax isax-message-question me-2" />
                    Feedback
                  </h6>
                  <div className="text-muted" style={{ whiteSpace: "pre-line" }}>
                    {parseMarkdownBold(
                      answerResult.feedback ||
                        answerResult.response?.feedback?.report ||
                        "No feedback provided."
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 mb-3">
              <div className="card h-100 border-0 bg-light">
                <div className="card-body">
                  <h6 className="text-dark mb-2">
                    <i className="isax isax-tick-circle me-2" />
                    Suggestions
                  </h6>
                  <div className="text-muted" style={{ whiteSpace: "pre-line" }}>
                    {parseMarkdownBold(
                      answerResult.suggestions ||
                        answerResult.response?.suggestions?.report ||
                        "No suggestions provided."
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnswerResult;

